import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { MiViewColors, MiViewFontSize, MiViewSpacing } from 'miview-ui/miviewTheme';

export const cardWrapperStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '2px 10px 0px 20px',
  borderBottom: `1px solid ${MiViewColors.softGray}`,

  '@media (max-width: 1700px)': {
    paddingLeft: '16px',
  },

  '@media (max-width: 1600px)': {
    paddingLeft: '14px',
  },

  '@media (max-width: 1400px)': {
    paddingLeft: '12px',
  },
};

export const iconBlockStyle: SxProps<Theme> = {
  position: 'relative',
  display: 'flex',
  height: '40px',
  borderRadius: '40px',
  background: MiViewColors.gray,
  alignItems: 'center',
  justifyContent: 'center',
  margin: '8px 20px 10px 0px',

  '@media (max-width: 1700px)': {
    marginRight: '16px',
  },
};

export const iconStyle: SxProps<Theme> = {
  color: MiViewColors.tertiary,
};

export const actionOrderBoxStyle: SxProps<Theme> = {
  position: 'absolute',
  left: '-8px',
  top: '-5px',
  width: '15px',
  height: '15px',
  fontSize: MiViewFontSize.xSmall,
  color: MiViewColors.tertiary,
  background: MiViewColors.primary,
  padding: '2px',
  borderRadius: '20px',
  textAlign: 'center',
};

export const versionBoxStyle: SxProps<Theme> = {
  position: 'absolute',
  left: '-8px',
  top: '25px',
  width: '15px',
  height: '15px',
  fontSize: MiViewFontSize.xSmall,
  color: MiViewColors.tertiary,
  background: MiViewColors.blue,
  padding: '2px',
  borderRadius: '20px',
  textAlign: 'center',
};

export const percentBoxStyle: SxProps<Theme> = {
  position: 'absolute',
  left: '25px',
  top: '25px',
  fontSize: MiViewFontSize.xSmall,
  color: MiViewColors.tertiary,
  background: MiViewColors.vividOrange,
  padding: '2px 4px',
  borderRadius: '20px',
  textAlign: 'center',
};

export const tacticGeneralInfoBlock: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  padding: '8px 8px 10px 0',
  marginTop: '0',
  marginBottom: 'auto',

  '@media (max-width: 1700px)': {
    paddingRight: '4px',
  },
};

export const channelBoxStyle: SxProps<Theme> = {
  marginBottom: '4px',
};

export const dateBoxStyle: SxProps<Theme> = {
  fontSize: MiViewFontSize.small,
};

export const descriptionBoxStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  overflowY: 'scroll',
  height: '72px',
  padding: '8px 2px 10px 2px',
};

export const subtitleStyle: SxProps<Theme> = {
  fontSize: MiViewFontSize.small,
};

export const menuBoxStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'left',
  alignItems: 'center',
  marginLeft: 'auto',
  marginRight: '0',
  paddingLeft: '4px',
};

export const lockBoxStyle: SxProps<Theme> = {
  border: `1px solid ${MiViewColors.vividOrange}`,
  borderRadius: '12px',
  padding: '2px 2px',
  display: 'flex',
  alignItems: 'center',
};

export const lockIconStyle: SxProps<Theme> = {
  width: '18px',
  height: '18px',
  color: MiViewColors.vividOrange,
  marginRight: '10px',
};

export const menuIconStyle: SxProps<Theme> = {
  color: MiViewColors.royalBlack,
  fontSize: MiViewFontSize.large,
  marginRight: 0,
  width: '24px',
  height: '24px',
};

export const menuButtonStyle: SxProps<Theme> = {
  minWidth: '38px',
  maxWidth: '38px',
  borderRadius: '40px',
};

export const groupSubtitleIconStyle: SxProps<Theme> = {
  width: '16px',
  height: '16px',
  marginRight: MiViewSpacing.xxSmall,
  color: MiViewColors.transparentGray,
};

export const groupSubtitleStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  color: MiViewColors.transparentGray,
  fontSize: MiViewFontSize.xSmall,
};
